export default __webpack_public_path__ + "static/media/well-th-view-user-guide.021ca823.pdf";